import api from 'api'
import { CACHE_TAG_CONTACT_VERSION_LIST, CACHE_TAG_CONTACT_VERSION_REFS } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    addUpdateContact: build.mutation({
      query: body => ({ url: '/api/account/contact', method: 'POST', body }),
      invalidatesTags: (result, error, body) => {
        const tags = []
        const accountId = result?.accountId
        const contactId = result?.contact?.id || body?.contact?.id
        if (accountId) tags.push({ type: CACHE_TAG_CONTACT_VERSION_REFS, id: accountId })
        if (contactId) tags.push({ type: CACHE_TAG_CONTACT_VERSION_LIST, id: contactId })
        return tags
      },
    }),
  }),
})

export const { useAddUpdateContactMutation } = extendedApi
